import moment from 'moment'
import { Conversion } from '../../models/Conversion'

interface DateCellProps {
  cellData: Conversion['created']
}

export const DateCell = (props: DateCellProps) => {
  const formatted = props.cellData
    ? moment.unix(props.cellData).format('MM/DD/YYYY')
    : '-'

  return <>{formatted}</>
}
